module.exports = __webpack_public_path__ + "static/media/NNLLs.f663214e.ipynb";